import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { memberAsMemberQueryKeys } from "./memberAsMemberQueryKeys";

export function useQueryMemberHighlightedInvoiceAsMember({
  api,
}: {
  api: ApiType;
}) {
  return useQuery({
    queryKey: memberAsMemberQueryKeys.highlightedInvoice(),
    queryFn: async () => {
      return (await api.profileApi.highlightedInvoice()).data;
    },
  });
}
